export enum FeaturesRoutingEnum {
  LDT = 'lead-delivery-time',
  DF = 'deployment-frequency',
}
